/* lua.js generated code 0.3.0 */

var UserLevelUtil = {}
UserLevelUtil.calcPassLevelRewardItems = function (levelId, scoreRef, oldScoreRef) {
    var [tmp, reward] = [{}, table()]
    var $limit7 = scoreRef.star
    for (let i = 1; i <= $limit7; i += 1) {
        var rewards
        if (i > oldScoreRef.star) {
            rewards = MetaManager.getInstance().getLevelDefaultRewards(levelId)
        } else {
            rewards = MetaManager.getInstance().getLevelNewStarRewards(i, levelId)
        }
        if ($len(rewards) > 0) {
            for (let i = 1, v = rewards[1]; v; i++, v = rewards[i]) {
                tmp[v.itemId] = (tmp[v.itemId] || 0) + v.num
            }
        }
    }
    for (var k in tmp) {
        var v = tmp[k]
        table.insert(reward, table([1, "itemId", parseInt(k, 10)], [1, "num", v]))
    }
    return reward
}
UserLevelUtil.recalcLevelScore = function (levelId) {
    var levelConfig = LevelConfigManager.getInstance().getLevelDigest(levelId)
    var score = UserManager.getInstance().getUserScore(levelId)
    if (!levelConfig || !score) {
        return 
    }
    let [star, ret] = [0, ScoreRef.create()]
    ret.score = score.score
    let $st19 = (levelConfig.scoreTargets || table())
    for (let i = 1, v = $st19[1]; v; i++, v = $st19[i]) {
        if (v < ret.score) {
            star = i
        }
    }
    ret.star = Math.max(star, score.star)
    return ret
}
module.exports = UserLevelUtil
